import React, { useState, useRef, useEffect } from 'react';
import { Filmstrip } from '@one-thd/sui-carousel';
import proptypes from 'prop-types';
import { CAROUSEL_BREAKPOINTS } from '../../statics';
import '../../super-sku.scss';

const { node, bool } = proptypes;

export const SuperSkuCarousel = (props) => {
  const {
    children,
    shouldUseCarousel
  } = props;
  const { LARGE: LARGE_BREAKPOINT, MEDIUM: MEDIUM_BREAKPOINT } = CAROUSEL_BREAKPOINTS;

  const attributeValues = children?.[0];
  const containerRef = useRef(null);
  const [slides, setSlides] = useState(4);

  useEffect(() => {
    if (!shouldUseCarousel) {
      return () => {};
    }
    const updateSlides = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        if (width > LARGE_BREAKPOINT) setSlides(4);
        else if (width > MEDIUM_BREAKPOINT) setSlides(3);
        else setSlides(2);
      }
    };
    updateSlides();
    const observer = new ResizeObserver(updateSlides);
    const container = containerRef.current;
    if (container) {
      observer.observe(container);
    }
    return () => {
      if (container) {
        observer.unobserve(container);
      }
    };
  }, [shouldUseCarousel, LARGE_BREAKPOINT, MEDIUM_BREAKPOINT]);

  return (
    shouldUseCarousel ? (
      <div data-testid="super-sku-carousel" ref={containerRef}>
        <div className="sui-w-full">
          <Filmstrip
            breakpoints={{}}
            slidesPerView={slides}
            disableMargin
          >
            {attributeValues}
          </Filmstrip>
        </div>
      </div>
    ) : (
      <>{children}</>
    )
  );
};

SuperSkuCarousel.displayName = 'SuperSkuCarousel';

SuperSkuCarousel.propTypes = {
  children: node.isRequired,
  shouldUseCarousel: bool
};

SuperSkuCarousel.defaultProps = {
  shouldUseCarousel: false
};